import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import  styles from "./dell.module.css";
import Head from "next/head";
import Image from 'next/image';
import Upsdelhibanner from "../../assets/images/upsc/Skill-Up-Brochure-Web-Banner.jpg";
import MobUpscdelhibanner from "../../assets/images/upsc/Skill-Up-Brochure-Mobile-Banner.jpg";
import Calendar from "../../assets/images/icon/Calender-01.png"; 
import Clock from "../../assets/images/icon/clock-01.png";


export default function index() {

  return (
    <>
    <Head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noodp,noydir" />
        <meta name="robots" content="index,follow" />
        <meta name="robots" content="index,follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
        <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
        <title>UPSC SkillUp Prelims Programme 2026 | Shankar IAS Academy</title>
        <meta name="title" content="UPSC SkillUp Prelims Programme 2026 | Shankar IAS Academy" />
        <meta name="description" content="Enroll in the UPSC SkillUp Prelims Programme 2026 by Shankar IAS Academy. Structured syllabus coverage, expert faculty guidance, mock tests, and proven strategies to crack UPSC Prelims." />
        <link rel="canonical" href="https://www.shankariasacademy.com/upsc-skillup-prelims-programme/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="UPSC SkillUp Prelims Programme 2026 | Shankar IAS Academy" />
        <meta property="og:description" content="Enroll in the UPSC SkillUp Prelims Programme 2026 by Shankar IAS Academy. Structured syllabus coverage, expert faculty guidance, mock tests, and proven strategies to crack UPSC Prelims." />
        <meta property="og:url" content="https://www.shankariasacademy.com/upsc-skillup-prelims-programme/" />
        <meta property="og:site_name" content="Shankar IAS Academy" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@shankarias" />
    </Head>

    <Navbar />

    <div className="container pt-3 ">
        <div className="rows pt-3 pb-3">
            <h1 className={`${styles.sectiontitle}`}>UPSC SkillUp Prelims Programme 2026</h1>
        </div>
    </div>

    <div className="container">
      <div className="row d-none d-md-block">
          <div className="col mb-3">
            <Image
              src={Upsdelhibanner}
              alt="orientation banner"
              title="UPSC orientation Test Series 2024"
              className="img-fluid w-100"
            />
          </div>
      </div>

      <div className="row d-block d-md-none">
        <div className="col mb-3">
          <Image
            src={MobUpscdelhibanner}
            alt="orientation banner"
            title="UPSC orientation"
            className="img-fluid w-100"
          />
        </div>
      </div>
    </div>

    <section className="pt-md-3 pt-lg-4" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
      <div className="container"> 
        <div className="row">
            <div className="col-12 col-xl-3 pt-2 ">
                <div className={`${styles.facultyborder1}  h-100`}>
                    <div className="row pt-3 pb-3">
                        <div className="col-6 col-xl-6 offset-xl-2">
                            <span >Start from:</span><br />
                            <span className={`${styles.dayValue}`}>05<sup>th</sup></span><br />
                            <span>Jan 2026</span>
                        </div>
                        <div className="col-6 col-xl-4 pt-3 pt-xl-0">
                          <Image src={Calendar} alt="clendar" width={50} height={50} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 col-xl-3 pt-2">
                <div className={`${styles.facultyborder1} h-100`}>
                  <div className="row pt-3 pb-3">
                      <div className="col-6 col-xl-6 offset-xl-2">
                        <span>Timings:</span><br />
                        <span className={`${styles.dayValue}`}>02:30 pm </span><br />
                        <span>05:00 pm</span>
                      </div>
                      <div className="col-6 col-xl-4 pt-3 pt-xl-0">
                        <Image src={Clock} alt="clendar" width={50} height={50} />
                      </div>
                  </div>
                </div> 
            </div>

            <div className="col-12 col-xl-6 pt-2">
              <div className={`${styles.facultyborder1} h-100`}>
                <div className="row pt-3 pb-3">
                    <div className="col-6 col-xl-4">   
                      <span>Fees (New Student)</span><br />
                      <span className={`${styles.dayValue}`}>Rs:10,000</span><span style={{fontSize:"12px" , color:"#7a7777ff"}}>(Incl. Tax)</span><br />
                      <span>(Online/Offline)</span><br />
                    </div>
                     <div className="col-6 col-xl-4 pt-2 pt-xl-0 ">   
                      <span>Fees (Old Student)</span><br />
                      <span className={`${styles.dayValue}`}>Rs:8,000</span><span style={{fontSize:"12px" , color:"#7a7777ff"}}>(Incl. Tax)</span><br />
                      <span>(Online/Offline)</span><br />
                    </div>

                    <div className="col-6 col-xl-4 pt-3 pt-xl-3">
                      <span><a target="_blank" href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=SKILL%20UP%20PRELIMS%202026"><button class={`${styles.normalbutton}`} type="submit">Pay Here</button></a></span>
                    </div>
                </div>
              </div>
            </div>
        </div>

        <div className="container">
          <div className="row">
              <div className="col-12 col-xl-6 pt-3">
                  <h5 className={`${styles.Feature} pt-3 mb-0`} >Program Overview - SkillUp for CSE Prelim 2026</h5>
                  <p className={`${styles.overview} pt-3 mb-0`}>
                    <span style={{fontWeight:"600" , color:"#001e62"}}>Philosophy :</span> The program operates on the premise that Prelim success is more about Thinking than Knowing . The program intends to build the necessary skills required byond knowledge so as to tackle the uncertainties in Prelim Question paper.
                  </p>
                  <p className={`${styles.overview} pt-3 mb-2 pb-2`}>
                    <span style={{fontWeight:"600" , color:"#001e62"}}>Core Concept : </span>It is not a test series, but a skill building system designed to train students to think clearly, filter options smartly, and maintain confidence during unpredictable exams
                  </p>
              </div>
                
              <div className="col-12 col-xl-6 text-center pt-5 "><a style={{color:"#000",fontSize:"18px"}} href="https://www.shankariasacademy.com/pdf/UPSC-2026/Upsc-Prelims-Skillup-2026/Skillup-Brochure.pdf" target="_blank"><i class="bi bi-file-earmark-pdf-fill" style={{fontSize:"35px",color:"#DB1B0D"}}></i> <br />Click here SkillUp Programme Brochure</a></div>                
          </div>
        </div>
      </div> 
    </section>

    <section>
      <div className="container pt-4">
          <div className="row g-4">
              <div className="col-md-6">
                <div className="p-4 rounded-4 h-100" style={{ background: "linear-gradient(to top, #f4f6f8, #fef5f5)", opacity: 1, }}>
                    <h4 className={`${styles.pagemaintitle} fw-bold mb-3 pt-3`}>Key Highlights & Structure</h4> 
                    <p className={`${styles.acheiverrank}pt-2`} style={{ fontSize: "16px" }}><b> Format : </b>The course consists of 50 high-intensity sessions</p>
                    <p className={`${styles.acheiverrank}pt-2`} style={{ fontSize: "16px" }}> <b>Content Delivery : </b> It covers 1000+ Topic Shots and provides predictive coverage driven by current UPSC trend analysis </p>
                    <p className={`${styles.acheiverrank}pt-2`} style={{ fontSize: "16px" }}> <b>Zero Burden: </b> It is designed to require no extra study burden or pre-reading; students simply need to attend and engage</p>
                    <div className={`${styles.acheiverrank}pt-2`}style={{ fontSize: "16px" }}>
                      Session Details:
                      <ul>
                          <li className="pb-2 pt-2"><b>Frequency :</b>  Days are Monday, Tuesday, Thursday, and Friday</li>
                          <li className="pb-2"><b>Workload : </b> Each session involves solving 20 curated UPSC standard questions</li>
                          <li className=""><b>Syllabus :</b> A balanced mix of static, dynamic, trend-driven themes, and select CSAT areas</li>
                      </ul>
                    </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-4 rounded-4  h-100"  style={{ background: "linear-gradient(to top, #f4f6f8, #fef5f5)", opacity: 1,}}>
                    <h4 className={`${styles.pagemaintitle} fw-bold`} style={{ color: "#1b1818ff" }}> Methodology (How it Works)</h4>
                    <p className={`${styles.acheiverrank}`}style={{ fontSize: "18px" }}>
                      The sessions follow a four-step process:
                    </p>
                    <ul className="list-unstyled pt-2 mb-0">

                      <li className={`${styles.acheiverrank}mb-2`} style={{ fontSize: "18px" }}>
                          ✔ <b> Attempt :</b> Solving 20 questions in the beginning of every session to build instinct and clarity
                      </li>

                      <li className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>
                          ✔ <b> Decode :</b> Breaking down questions to understand elimination techniques and takeaways
                      </li>

                      <li  className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>
                          ✔ <b> Absorb : </b> Organically picking up high-yield topics without separate preparation
                      </li>

                      <li  className={`${styles.acheiverrank}mb-2 pt-3`} style={{ fontSize: "18px" }}>
                          ✔ <b> Evolve : </b> Improving reasoning, speed, and composure session by session
                      </li>

                    </ul>
                </div>
              </div>
          </div>
      </div>
    </section>

    <section>
      <div className="container pt-4">
        <div className="row">
          <div className="mb-5">

              <h3 className={`${styles.pagemaintitle}  text-center fw-bold mb-3 pt-3`}>
                Target Audience
              </h3>
              <p className={`${styles.acheiverrank}  text-center `}style={{ fontSize: "18px" }}>
                The program claims to work for all levels:
              </p>

              <div className="row justify-content-center pt-3">
                <div className="col-md-8">
                  <ul className="list-group list-group-flush shadow-sm border rounded-3">
                    <li className="list-group-item py-3">
                      <span className="fw-bold text-primary">1. </span> <b> Beginners :</b> To build concepts and thinking skills
                    </li>
                    <li className="list-group-item py-3">
                      <span className="fw-bold text-primary">2. </span> <b> Veterans :</b>  To sharpen judgment and elimination skills
                    </li>
                    <li className="list-group-item py-3">
                      <span className="fw-bold text-primary">3. </span> <b> Working Aspirants :</b>  Because no pre-reading is required
                    </li>
                    <li className="list-group-item py-3">
                      <span className="fw-bold text-primary">4. </span> <b> Students in Coaching :</b> It is fully compatible with ongoing classes and test series
                    </li>
                  </ul>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
    </>
  )
}
